<template>
  <div class="point block relative" :class="this.class">
    <!-- Background circle -->
    <svg
      class="round_bg absolute"
      :style="[
        getBGStrokeStyle,
        {
          strokeWidth: strokeWidth,
          transform: 'rotate(' + startDegree + 'deg)',
        },
      ]"
      viewbox="0 0 100 100"
      :width="width"
      :height="height"
      data-percent="89"
    >
      <circle :cx="width / 2" :cy="height / 2" :r="radius" />
    </svg>

    <!-- Main circle -->
    <svg
      :class="['round z-10', circle1Class, progress2 && steps2 && 'absolute']"
      viewbox="0 0 100 100"
      :width="width"
      :height="height"
      data-percent="89"
      :style="[
        getStrokeStyle1,
        {
          strokeWidth: strokeWidth,
          transform: 'rotate(' + startDegree + 'deg)',
        },
      ]"
    >
      <circle :cx="width / 2" :cy="height / 2" :r="radius" />
    </svg>

    <!-- Team circle -->
    <svg
      v-if="progress2 && steps2"
      class="round absolut"
      :class="circle2Class"
      viewbox="0 0 100 100"
      :width="width"
      :height="height"
      data-percent="89"
      :style="[
        getStrokeStyle2,
        {
          strokeWidth: strokeWidth - 1,
          transform: 'rotate(' + startDegree + 'deg)',
        },
      ]"
    >
      <circle :cx="width / 2" :cy="height / 2" :r="radius" />
    </svg>
    <div class="absolute -translate-y-1/2 -translate-x-1/2 top-2/4 left-2/4">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressCircle",
  props: {
    progress: Number,
    steps: Number,
    progress2: Number,
    steps2: Number,
    class: String,
    circle1Class: {
      type: String,
      default: "stroke-bkk-100",
    },
    circle2Class: {
      type: String,
      default: "stroke-black",
    },
    height: {
      type: Number,
      default: 100,
    },
    width: {
      type: Number,
      default: 100,
    },
    radius: {
      type: Number,
      default: 75,
    },
    strokeWidth: {
      type: Number,
      default: 19,
    },
    startDegree: {
      type: Number,
      default: -210,
    },
    rangeDegree: {
      type: Number,
      default: 315,
    },
    showProgress: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    getStrokeStyle1() {
      return this.calculateStrokeStyle(this.progress, this.steps);
    },
    getStrokeStyle2() {
      return this.calculateStrokeStyle(this.progress2, this.steps2);
    },
    getBGStrokeStyle() {
      //at radius 30 and 187 the circle is at 100%
      const extra = this.radius / 30;
      const pixelMultiplier = (this.rangeDegree / 360) * 187 * extra;
      return `stroke-dasharray: ${pixelMultiplier} 999`;
    },
  },
  methods: {
    calculateStrokeStyle(progress, steps) {
      //at radius 30 and 187 the circle is at 100%
      const extra = this.radius / 30;
      const pixelMultiplier = (this.rangeDegree / 360) * 187 * extra;
      const strokeWidth = (progress / steps) * pixelMultiplier;
      return `stroke-dasharray: ${strokeWidth} 999`;
    },
  },
};
</script>

<style>
.round {
  transition: all 1s ease-in-out;
  fill: none;
  stroke-linecap: round;
}

.round_bg {
  @apply stroke-light-gray;
  transition: all 1s ease-in-out;
  fill: none;
  stroke-linecap: round;
}
</style>
